import Button from "@/Components/Button/Button";
import { useTranslation } from "react-i18next";

interface HeaderProps {
  isPending: boolean;
}

const Header = ({ isPending }: HeaderProps) => {
  const { t } = useTranslation("", { keyPrefix: "settings_page" });

  return (
    <div className="flex justify-between">
      <h1>{t("websiteSetting")}</h1>
      <Button
        data-tour="website-settings.save"
        type="submit"
        style={{
          marginTop: "20px",
          marginBottom: "20px",
        }}
        isPending={isPending}
      >
        {t("save")}
      </Button>
    </div>
  );
};

export default Header;
